import React from 'react';
import useMedia from 'use-media';
import CommonUtil from '../../../common/commonUtil';
import { BlackCheckBox } from "../../atoms/RTCC/blackCheckBox";

export const AcceptForm = (props) => {
    const { data, onChange, onClick, name, endLabel } = props;
    const isWideTablet = useMedia({ maxWidth: '960px' });
    return (
        <div style={{ padding: "10px 0px 0px 0px" }}>
            {data ? data.map((d, index) => (
                <div key={"condition" + index} style={{ display: "flex" }}>
                    <BlackCheckBox
                        name={name}
                        className={props.checkBoxClassName}
                        onChange={onChange}
                        value={d.id}
                        defaultChecked={d.checked} />
                    <div style={props.conditionLabelStyle} onClick={() => onClick(
                        d.type, CommonUtil.replaceSpecialChar(d.contents)
                    )}>{d.type}</div>
                    <label style={props.endLabelStyle}>{endLabel}</label>
                </div>
            )) : null}
        </div>
    );
}
const styles = {
}